import React from "react";

export default ({category, css}) => {
  css += " category tag is-" + (category === 'Article' ? 'info' : 'success');
  return <span className={css}>{category}</span>
};